import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
const ContactSection = () => {
  return <section className="py-16 md:py-24 bg-gradient-subtle">
      <div className="container-comfortable">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Ihre kostenlose Beratung wartet
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto text-balance mb-4">
            Sprechen Sie mit unseren Experten und finden Sie die beste 
            Lösung für Ihre persönliche Situation.
          </p>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto">
            Die Erstberatung bei eigenheimverrentung.de ist 100 % kostenlos und unverbindlich. Unsere Experten beraten Sie neutral zu allen 6 Verrentungsmodellen – ohne versteckte Kosten oder Provisionen. Telefonisch erreichbar unter 089 62 82 46 46, Mo–Fr 9:00–18:00 Uhr.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <Card className="card-elevated text-center">
            <CardHeader className="pb-4">
              <div className="bg-accent/10 p-4 rounded-xl w-fit mx-auto mb-2">
                <Phone className="h-6 w-6 text-accent" />
              </div>
              <CardTitle className="text-xl">Telefon</CardTitle>
            </CardHeader>
            <CardContent>
              <button 
                className="text-2xl font-bold text-primary mb-2 hover:text-primary-hover transition-colors cursor-pointer"
                onClick={() => window.open('tel:089628246446', '_self')}
              >
                089 62 82 46 46
              </button>
              
            </CardContent>
          </Card>

          <Card className="card-elevated text-center">
            <CardHeader className="pb-4">
              <div className="bg-accent/10 p-4 rounded-xl w-fit mx-auto mb-2">
                <Clock className="h-6 w-6 text-accent" />
              </div>
              <CardTitle className="text-xl">Öffnungszeiten</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-lg font-semibold text-primary mb-1">
                Mo-Fr: 9:00 - 18:00 Uhr
              </p>
              <p className="text-muted-foreground">
                Persönliche Beratung
              </p>
            </CardContent>
          </Card>

          <Card className="card-elevated text-center">
            <CardHeader className="pb-4">
              <div className="bg-accent/10 p-4 rounded-xl w-fit mx-auto mb-2">
                <Mail className="h-6 w-6 text-accent" />
              </div>
              <CardTitle className="text-xl">E-Mail</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-lg font-semibold text-primary mb-2 text-center w-full">
                info@renteplusimmobilie.de
              </p>
              <p className="text-muted-foreground">
                Antwort binnen 24 Stunden
              </p>
            </CardContent>
          </Card>

          <Card className="card-elevated text-center">
            <CardHeader className="pb-4">
              <div className="bg-accent/10 p-4 rounded-xl w-fit mx-auto mb-2">
                <MapPin className="h-6 w-6 text-accent" />
              </div>
              <CardTitle className="text-xl">Vor Ort</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-lg font-semibold text-primary mb-2">
                Deutschlandweit
              </p>
              <p className="text-muted-foreground">
                Persönliche Beratung bei Ihnen zu Hause
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-card border border-border rounded-xl p-8 shadow-card">
            <h3 className="text-2xl font-bold text-primary mb-4">
              Jetzt unverbindlichen Beratungstermin vereinbaren
            </h3>
            <p className="text-lg text-muted-foreground mb-6">
              Unsere Experten nehmen sich ausreichend Zeit für Ihre Fragen 
              und entwickeln gemeinsam mit Ihnen die optimale Lösung.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="accent" 
                size="lg" 
                className="text-xl px-8"
                onClick={() => window.open('tel:089628246446', '_self')}
              >
                <Phone className="h-5 w-5 mr-2" />
                Jetzt anrufen
              </Button>
              <Button variant="outline" size="lg" className="text-xl px-8" onClick={() => window.open("mailto:info@renteplusimmobilie.de", "_self")}>
                <Mail className="h-5 w-5 mr-2" />
                E-Mail senden
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ContactSection;